import { component } from 'picoapp';
import Swiper, { Autoplay } from 'swiper';

export default component((node) => {
  if (!node) return;
  const sliderWrapper = node.querySelector('.swiper-wrapper');
  if (!sliderWrapper) return;

  const mobileMenuLoop = sliderWrapper.dataset.mobileMenuLoop === 'true';
  if (!mobileMenuLoop) return;

  const loopSpeedRaw = Number(sliderWrapper.dataset.mobileMenuLoopSpeed);
  const loopSpeed = !Number.isNaN(loopSpeedRaw) ? loopSpeedRaw * 1000 : 0;

  const isSliderOverflowing = node.scrollWidth > node.getBoundingClientRect().width;
  if (!isSliderOverflowing) return;

  let slider;
  let lastWidth = window.innerWidth;
  const THRESHOLD = 50;
  let restartTimer = null;
  const RESTART_DELAY = 20;
  const initSlider = () => {
    const reset = () => {
      if (typeof slider !== 'undefined' && slider?.destroy) {
        slider.destroy();
      }

      sliderWrapper.classList[isSliderOverflowing ? 'remove' : 'add']('justify-center');

      slider = new Swiper(node, {
        modules: [Autoplay],
        slidesPerView: 'auto',
        spaceBetween: 35,
        speed: loopSpeed,
        loop: true,
        centeredSlides: true,
        loopPreventsSlide: true,
        loopAdditionalSlides: 100,
        allowTouchMove: true,
        autoplay: {
          delay: 1,
          disableOnInteraction: false,
          reverseDirection: false,
        },
        on: {
          touchStart() {
            if (slider.autoplay) slider.autoplay.stop();
            if (restartTimer) clearTimeout(restartTimer);
          },
          touchEnd() {
            if (restartTimer) clearTimeout(restartTimer);
            restartTimer = setTimeout(() => {
              if (!slider || slider.destroyed) return;

              slider.params.autoplay.reverseDirection = false;

              if (slider.autoplay) slider.autoplay.start();
              restartTimer = null;
            }, RESTART_DELAY);
          },
          pointerUp() {
            if (restartTimer) clearTimeout(restartTimer);
            restartTimer = setTimeout(() => {
              if (!slider || slider.destroyed) return;
              slider.params.autoplay.reverseDirection = false;
              if (slider.autoplay) slider.autoplay.start();
              restartTimer = null;
            }, RESTART_DELAY);
          },
        },
      });
      originalAutoplayReverse = slider.params.autoplay.reverseDirection;
    };

    const resizeHandler = () => {
      const currentWidth = window.innerWidth;
      if (Math.abs(currentWidth - lastWidth) >= THRESHOLD) {
        reset();
        lastWidth = currentWidth;
      }
    };

    reset();
    window.removeEventListener('resize', resizeHandler);
    window.addEventListener('resize', resizeHandler, { passive: true });
  };

  initSlider();
});
